export default {
  'menu.dashboard': 'Dashboard',
  'menu.virtual-office': 'Virtual Office',
  'menu.roles-and-users': 'Roles and Users',
  'menu.all-role-calls': 'All Role Calls',
  'menu.calls': 'Call Management',
  'menu.calls.active': 'Active Calls',
  'menu.calls.logs': 'Call Logs',
  'menu.calls.recordings': 'Recordings',
  'menu.csr': 'CSR Management',
  'menu.csr.agents': 'Agents',
  'menu.csr.performance': 'Performance',
  'menu.contacts': 'Contacts',
  'menu.settings': 'Settings',
  
  // Common
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Create',
  'common.search': 'Search',
  'common.reset': 'Reset',
  'common.submit': 'Submit',
  'common.confirm': 'Confirm',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.loading': 'Loading...',
  'common.success': 'Success',
  'common.error': 'Error',
  'common.warning': 'Warning',
  'common.info': 'Info',
  
  // Login
  'login.title': 'Virtual Call Center',
  'login.subtitle': 'AI-Powered Customer Service Platform',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.submit': 'Login',
  'login.success': 'Login successful!',
  'login.failed': 'Login failed. Please check your credentials.',
  
  // User
  'user.logout': 'Logout',
  'user.settings': 'Settings',
  'user.profile': 'Profile',
};

